import React from "react"
import PropTypes from "prop-types"

import Person from "@components/person"

import { speaker_grid, speakers_header } from "./styles.module.scss"

const Speakers = ({ speakersCollection }) => {
  if (!speakersCollection || speakersCollection.items.length < 1) return <div></div> // Empty div necessary for parent grid

  const multipleSpeakers = speakersCollection.items.length > 1

  return (
    <div>
      <h3 className={speakers_header}>Speaker{multipleSpeakers ? "s" : ""}</h3>
      <div className={speaker_grid}>
        {speakersCollection.items.map((speaker, idx) => {
          const hasMultipleAssets = speaker.linkedFrom?.entryCollection?.total > 1
          const url = `/people/${speaker.slug}`
          return (
            <Person
              key={idx}
              image={speaker.image.url}
              name={speaker.name}
              description={speaker.description}
              url={hasMultipleAssets ? url : null}
            />
          )
        })}
      </div>
    </div>
  )
}

Speakers.propTypes = {
  /**
   * The collection of speakers.
   */
  speakersCollection: PropTypes.shape({
    items: PropTypes.array
  })
}

export default Speakers
